import { Pipe, PipeTransform } from '@angular/core';
import { ItemViewModel } from '@wilson/interfaces';

@Pipe({
  name: 'timelineFilterShiftToAssignPipe',
  standalone: true,
})
export class TimelineFilterShiftToAssignPipe implements PipeTransform {
  transform(shiftViews: ItemViewModel[], shiftToAssignId: string) {
    const shiftToAssignView = shiftViews.find(
      (view) => view.shift.id === shiftToAssignId,
    );

    return shiftToAssignView;
  }
}
